// src/i18n/ops.ts —— 06 admin-console C-02 / C-19 / C-23 / C-26 文案包（仪表盘 / Webhook·任务日志 / 操作记录 / 告警；经 PageDef.i18n 挂入 table 域字典，TD-849）。
// 06 给出文案的键逐字取 06（含 Toast 映射表）；06 未给英文或未给键名的标「本计划定稿」（W-7 回写）。
// 外壳包已定义的 alerts / audit / featurePending 不在此重复定义
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_OPS: I18nPack = {
  zh: {
    // C-02 资金健康度卡 / 列表卡
    liabilitySum: '用户负债合计',
    coverage: '卡侧覆盖率', // [改写 key]
    netInflow: '净入金',
    healthLow: '偏低',
    healthBad: '不足',
    stKycNone: '未认证',
    // C-19 Webhook / 任务日志
    cCardOrder: 'card_id / order', // 本计划定稿（与原型列字面一致）
    stReceived: '已接收',
    stSkipped: '已跳过',
    taskOverdue: '超 24h · 已告警',
    cLastTrace: '最近 trace_id',
    cLastRef: '最近关联单据',
    recentCalls: '最近 20 次调用',
    // C-23 操作记录
    errUserNotFound: '未找到该用户',
    actorUser: '用户',
    actorAgent: '代理',
    actorAdmin: '管理员',
    actorSystem: '系统',
    actorBot: 'Bot',
    actorWebhook: '回调',
    chH5: 'H5',
    chMiniapp: 'Mini App',
    chBot: 'Bot',
    chAgent: '代理中心',
    chAdmin: '后台',
    chWorker: '任务',
    chWebhook: '回调',
    chSystem: '系统',
    opSnapshot: '变更快照',
    opApiCalls: '关联上游调用',
    opWebhooks: '关联回调事件',
    // C-26 告警
    tabAlerts: ['未处理', '已确认', '全部'], // 本计划定稿（W-7）
    sevWarn: '警告',
    sevCritical: '严重',
    stAlertOpen: '未处理',
    stAlertAcked: '已确认',
    aAck: '确认',
    toastAck: '告警已确认',
    // 06 C-26 列表规格列名（06 未给键名，shl 前缀）
    shlAlertKind: '告警',
    shlAlertLevel: '级别',
    shlAlertCount: '次数',
    shlAlertFirst: '首次',
    shlAlertLast: '最近',
    shlAlertAcker: '确认人',
    toastTask: 'GET /task 已返回：{status}', // [改写为模板]（06 Toast 映射）
    // 本波自造键（obs 前缀）：06 给出文案、未给键名
    obsQuotaStale: '额度同步失败，显示为上次成功值', // C-02 代付剩余额度 stale
    obsActor: '主体', // C-23 列「主体」
    obsAction: '动作', // C-23 列「动作」（原型 cAction 为「触发动作」）
    obsSubject: '所涉用户', // C-23 列「所涉用户」
    obsResult: '结果', // C-23 列「结果」（原型 cResult 为「处理结果」）
    obsRefDoc: '关联单据', // C-19 / C-23 抽屉
    obsError: '错误', // C-19 Webhook 抽屉
    obsAlertType: '告警类型', // C-26 抽屉
    obsAckBy: '确认人 · 时间', // C-26 抽屉
  },
  en: {
    liabilitySum: 'User liabilities',
    coverage: 'Card coverage',
    netInflow: 'Net inflow',
    healthLow: 'Low',
    healthBad: 'Insufficient',
    stKycNone: 'Unverified', // 本计划定稿
    cCardOrder: 'card_id / order',
    stReceived: 'Received',
    stSkipped: 'Skipped',
    taskOverdue: 'Over 24h · alerted', // 本计划定稿
    cLastTrace: 'Last trace_id', // 本计划定稿
    cLastRef: 'Last reference', // 本计划定稿
    recentCalls: 'Last 20 calls', // 本计划定稿
    errUserNotFound: 'User not found', // 本计划定稿
    actorUser: 'User', // 本计划定稿
    actorAgent: 'Agent', // 本计划定稿
    actorAdmin: 'Admin', // 本计划定稿
    actorSystem: 'System', // 本计划定稿
    actorBot: 'Bot',
    actorWebhook: 'Webhook', // 本计划定稿
    chH5: 'H5',
    chMiniapp: 'Mini App',
    chBot: 'Bot',
    chAgent: 'Agent portal', // 本计划定稿
    chAdmin: 'Admin console', // 本计划定稿
    chWorker: 'Worker', // 本计划定稿
    chWebhook: 'Webhook', // 本计划定稿
    chSystem: 'System', // 本计划定稿
    opSnapshot: 'Snapshot',
    opApiCalls: 'Outbound calls',
    opWebhooks: 'Webhook events',
    tabAlerts: ['Open', 'Acknowledged', 'All'], // 本计划定稿（W-7）
    sevWarn: 'Warning', // 本计划定稿
    sevCritical: 'Critical', // 本计划定稿
    stAlertOpen: 'Open', // 本计划定稿
    stAlertAcked: 'Acknowledged', // 本计划定稿
    aAck: 'Acknowledge',
    toastAck: 'Alert acknowledged',
    shlAlertKind: 'Alert', // 本计划定稿
    shlAlertLevel: 'Severity', // 本计划定稿
    shlAlertCount: 'Count', // 本计划定稿
    shlAlertFirst: 'First seen', // 本计划定稿
    shlAlertLast: 'Last seen', // 本计划定稿
    shlAlertAcker: 'Acknowledged by', // 本计划定稿
    toastTask: 'GET /task returned: {status}',
    obsQuotaStale: 'Quota sync failed; showing the last successful value', // 本计划定稿
    obsActor: 'Actor', // 本计划定稿
    obsAction: 'Action', // 本计划定稿
    obsSubject: 'Subject user', // 本计划定稿
    obsResult: 'Result', // 本计划定稿
    obsRefDoc: 'Related record', // 本计划定稿
    obsError: 'Error', // 本计划定稿
    obsAlertType: 'Alert type', // 本计划定稿
    obsAckBy: 'Acknowledged by · at', // 本计划定稿
  },
};

// TD-805：覆盖原型字典的键（06 [改写 key]）
export const REWRITES_OPS: readonly string[] = ['coverage', 'toastTask'];
